import { useTranslation } from 'react-i18next';

const TextosGraciasPeticion = () => {
    const { t } = useTranslation();
    return (
        <div className="container mt-5">
            <h3 className="centra">{t("Gracias por su solicitud de reserva. En breve confirmaremos su solicitud y le indicaremos la forma de pago. Un cordial saludo")}</h3>
        </div>
    );
}

export default TextosGraciasPeticion;